import ScrollTrigger from 'gsap/ScrollTrigger';
import { lg } from '../common';
import { ParticleWaveBackground } from '../lib/ParticleWaveBackground';

function prefersReducedMotion() {
  if (document.documentElement.classList.contains('is-no-motion')) return true;

  return window.matchMedia(
    '(prefers-reduced-motion: reduce), (update: slow)',
  ).matches;
}

export function initWllFinalCta(parent) {
  if (!parent || prefersReducedMotion()) return;

  const animationBgEl = parent.querySelector('.wll-final-cta__bg');
  if (!animationBgEl) return;

  const animation = new ParticleWaveBackground(animationBgEl, {
    planeWidth: 7,
    planeHeight: 5,
    widthSegments: 120,
    heightSegments: 70,
    particleSize: 0.02,
    sizeScale: 0.7,
    waveHeight: 0.5,
    noiseScale: 2,
    animationSpeed: 6000,
    gradient: [
      { color: '#ffffffff', stop: 0 },
      { color: '#ffffffff', stop: 100 },
    ],
    rotation: { x: 30, y: 0, z: 0 },
    cameraPosition: [0, 0.2, 4.2],
    cameraRotation: { x: 0, y: 0, z: 0 },
    autoStart: false,
    hoverRadius: 1,
    hoverStrength: 0.5,
    hoverSpringStiffness: 40,
    hoverSpringDamping: 10,
    breakpoints: {
      [lg]: {
        planeWidth: 14,
        planeHeight: 5,
        particleSize: 0.025,
      },
    },
  });

  ScrollTrigger.create({
    trigger: parent,
    start: 'top bottom',
    end: 'bottom top',
    onEnter: () => animation.startAnimation(),
    onLeave: () => animation.stopAnimation(),
    onEnterBack: () => animation.startAnimation(),
    onLeaveBack: () => animation.stopAnimation(),
  });
}

export function initAllWllFinalCtas(selector = '.js-wll-final-cta') {
  const blocks = document.querySelectorAll(selector);
  blocks.forEach((block) => initWllFinalCta(block));
}
